import * as React from "react";
import { forwardRef } from "react";
const SvgArrowDownSm = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 17, height: 9, viewBox: "0 0 17 9", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M1 1L8.50007 7L16 1", stroke: "#CCCCCC", strokeWidth: 2, strokeLinecap: "round" }));
const ForwardRef = forwardRef(SvgArrowDownSm);
export default ForwardRef;
